import { api } from "./api";

export type ExportFormat = "zip" | "csv" | "combined";

export type ExportPreview = {
  count: number;
  totalBytes: number;
  items: { id: string; vendor: string | null; receiptDate: string | null; bytes: number }[];
};

export function fetchExportPreview(ids: string[]): Promise<ExportPreview> {
  return api.get<ExportPreview>(`/api/export/preview?ids=${ids.map(encodeURIComponent).join(",")}`);
}

export async function downloadExport(receiptIds: string[], format: ExportFormat): Promise<void> {
  const res = await fetch("/api/export", {
    method: "POST",
    credentials: "same-origin",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ receiptIds, format }),
  });
  if (!res.ok) {
    let msg = "Export fehlgeschlagen";
    try {
      const j = await res.json();
      msg = (j && typeof j === "object" && "error" in j) ? String((j as Record<string, unknown>).error) : msg;
    } catch { /* ignore */ }
    throw new Error(msg);
  }
  const blob = await res.blob();
  const cd = res.headers.get("Content-Disposition") ?? "";
  const m = /filename="?([^"]+)"?/.exec(cd);
  const name = m?.[1] ?? (format === "csv" ? "quittungen.csv" : "quittungen.zip");
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(0)} KB`;
  return `${(n / 1024 / 1024).toFixed(1)} MB`;
}
